<template>
    <div class=" bg-[#000000] text-[#14C100] p-4 rounded-lg">
      <!-- Chart container -->
      <div ref="chartContainer" class="w-full h-64"></div>

      <div class="mt-4 pt-4 border-t border-[#2E2E2E]">

				<div class="flex space-x-2 justify-between mb-4">
        <p
          class="px-3 py-1 rounded cursor-pointer hover:bg-[#14C100] hover:text-[#FFFFFF]"
          :class="timeframe === 'Today' ? 'text-[#FFFFFF]' : 'text-[#14C100]'"
          @click="timeframe = 'Today'"
        >
          Today
        </p>
        <p
          class="px-3 py-1 rounded cursor-pointer hover:bg-[#14C100] hover:text-[#FFFFFF]"
          :class="timeframe === '1w' ? 'text-[#FFFFFF]' : 'text-[#14C100]'"
          @click="timeframe = '1w'"
        >
          1w
        </p>
        <p
          class="px-3 py-1 rounded cursor-pointer hover:bg-[#14C100] hover:text-[#FFFFFF]"
          :class="timeframe === '2w' ? 'text-[#FFFFFF]' : 'text-[#14C100]'"
          @click="timeframe = '2w'"
        >
          2w
        </p>
				<p
          class="px-3 py-1 rounded cursor-pointer hover:bg-[#14C100] hover:text-[#FFFFFF]"
          :class="timeframe === '3w' ? 'text-[#FFFFFF]' : 'text-[#14C100]'"
          @click="timeframe = '3w'"
        >
          3w
        </p>
				<p
          class="px-3 py-1 rounded cursor-pointer hover:bg-[#14C100] hover:text-[#FFFFFF]"
          :class="timeframe === '4w' ? 'text-[#FFFFFF]' : 'text-[#14C100]'"
          @click="timeframe = '4w'"
        >
          4w
        </p>
				<p
          class="px-3 py-1 rounded cursor-pointer hover:bg-[#14C100] hover:text-[#FFFFFF]"
          :class="timeframe === '1y' ? 'text-[#FFFFFF]' : 'text-[#14C100]'"
          @click="timeframe = '1y'"
        >
          1y
        </p>
				<p
          class="px-3 py-1 rounded cursor-pointer hover:bg-[#14C100] hover:text-[#FFFFFF]"
          :class="timeframe === '5y' ? 'text-[#FFFFFF]' : 'text-[#14C100]'"
          @click="timeframe = '5y'"
        >
          5y
        </p>
      </div>

      </div>

    </div>
  </template>
  
  <script>
  import * as echarts from 'echarts';
  import apiClient from '@/axios';
  
  export default {
    props: {
      projectId: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        chart: null,
        timeframe: '1d',
        chartType: 'line',
        data: [], // Initialize as empty, will be populated from API
      };
    },
    watch: {
      timeframe() {
        this.fetchChartData(); // Fetch data for the selected timeframe
      },
    },
    mounted() {
      this.initChart();
      this.fetchChartData(); // Fetch initial data
      window.addEventListener('resize', this.resizeChart);
    },
    beforeUnmount() {
      if (this.chart) {
        this.chart.dispose();
      }
      window.removeEventListener('resize', this.resizeChart);
    },
    methods: {
      async fetchChartData() {
        try {
          const response = await apiClient.get(`/web/wallet/inflow/chart/${this.projectId}`, {
            params: { period: this.timeframe },
          });
          this.data = response.data.data; // Update chart data
          this.renderChart(); // Re-render chart with new data
        } catch (error) {
          console.error('Error fetching chart data:', error);
        }
      },
      initChart() {
        this.chart = echarts.init(this.$refs.chartContainer);
        this.renderChart();
      },
      renderChart() {
        if (!this.chart) return;
  
        const dates = this.data.map(item => item.date);
        const totals = this.data.map(item => item.total);
  
        const lineOption = {
          backgroundColor: '#000000',
          tooltip: { show: false },
          grid: { left: '0', right: '0', top: '0', bottom: '0', containLabel: false },
          xAxis: { type: 'category', data: dates, show: false },
          yAxis: { type: 'value', show: false },
          series: [
            {
              data: totals,
              type: 'line',
              smooth: false,
              symbol: 'none',
              lineStyle: { width: 3, color: '#14C100' },
              areaStyle: {
                opacity: 0.2,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 1, color: 'rgba(20, 193, 0, 0.05)' },
                ]),
              },
            },
          ],
        };
  
        this.chart.setOption(lineOption);
      },
      resizeChart() {
        if (this.chart) {
          this.chart.resize();
        }
      },
    },
  };
  </script>
  
  <style scoped>
  /* Add any specific styles here */
  </style>